module.exports = __webpack_public_path__ + "media/images/salon-315ee409871db4e7ec51a1ef638c610f.jpeg";